import axios from 'axios';
import ApiGet from '../../sections/mainheader/apiget';


class DistributorClaimApprovalService {
    constructor(apiUrl) {
        this.GetApiUrl = apiUrl;
        this.GetStatusOfPODDocuments = (payload) => (axios.post(`${this.GetApiUrl}POD/GetStatusOfPODDocuments`,payload));
        // NOSONAR  this.DistributorClaimApprovalButtons = (payload) => (axios.post(`${this.GetApiUrl}approvalprocess/DistributorClaimApproval`, payload));
        this.DistributorClaimApprovalButtons = (payload) => (axios.post(`${this.GetApiUrl}ContractClaimApproval/ApproveDistributorClaim/true`, payload));
      // NOSONAR this.GetStatusOfDistributorClaimApproval = (id) => (axios.get(`${this.GetApiUrl}ApprovalProcess/GetStatusOfDistributorClaimApproval/${id}`));
        this.ContractClaimApproval = (id) => (axios.get(`${this.GetApiUrl}ApprovalProcess/GetStatusOfDistributorClaimApproval/${id}`));
   
    }
}


export default ApiGet().then((apiUrl) => new DistributorClaimApprovalService(apiUrl));

